<template>
  <div class="widget-loader-container">
    <div
      class="widget-loader-background"
      :style="{
        '--loader-background': widgetColor,
      }"
    />
    <div
      class="widget-loader-spinner"
      :style="{
        '--loader-color': textColor,
      }"
    />
  </div>
</template>

<script>
import { getContrastingTextColor } from '@chatwoot/utils';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),

    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
  },
};
</script>

<style lang="scss">
.widget-loader-container {
  @apply absolute h-full w-full flex items-center justify-center;

  .widget-loader-background {
    @apply absolute opacity-25 h-full w-full;

    z-index: 100;
    background: var(--loader-background);
  }

  .widget-loader-spinner {
    @apply absolute h-16 w-16 rounded-full border-4 border-solid;

    z-index: 100;
    border-color: var(--loader-color);
    border-right-color: transparent;

    animation: rotation 1s ease-in-out infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
